/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/10/21
 */

import { ReactComponent as ErrorIcon } from './Error_BLK_RGB.svg';
import { ReactComponent as InfoIcon } from './Info_BLK_RGB.svg';
import { ReactComponent as FAQIcon } from './FAQs_BLK_RGB.svg';
import { ReactComponent as DownloadIcon } from './Downloads_BLK_RGB.svg';
import { ReactComponent as CloseIcon } from './Close_BLK_RGB.svg';
import { ReactComponent as ProfileIcon } from './Profile_Login_BLK_RGB.svg';
import { ReactComponent as SearchIcon } from './Search_BLK_RGB.svg';
import { ReactComponent as SettingsIcon } from './Settings_02_BLK_RGB.svg';
import { ReactComponent as UploadIcon } from './Upload_BLK_RGB.svg';
import { ReactComponent as ArrowLeftIcon } from './Arrow_Left_BLK_RGB.svg';
import { ReactComponent as ArrowRightIcon } from './Arrow_Right_BLK_RGB.svg';
import { ReactComponent as ArrowUpIcon } from './Arrow_Up_BLK_RGB.svg';
import { ReactComponent as ArrowDownIcon } from './Arrow_Down_BLK_RGB.svg';
import { ReactComponent as PointerLeftIcon } from './Pointer_Left_BLK_RGB.svg';
import { ReactComponent as PointerRightIcon } from './Pointer_Right_BLK_RGB.svg';
import { ReactComponent as PointerUpIcon } from './Pointer_Up_BLK_RGB.svg';
import { ReactComponent as PointerDownIcon } from './Pointer_Down_BLK_RGB.svg';
import { ReactComponent as CalendarIcon } from './Calendar_BLK_RGB.svg';
import { ReactComponent as MenuIcon } from './Menu_Burger_BLK_RGB.svg';
import { ReactComponent as RSVPIcon } from './RSVP.svg';
import { ReactComponent as ClockIcon } from './Clock.svg';
import { ReactComponent as CourseCodeIcon } from './Course_Code.svg';
import { ReactComponent as LinkIcon } from './Link.svg';
import { ReactComponent as ExternalLinkIcon } from './External_Link.svg';
import { ReactComponent as QualificationIcon } from './Qualification.svg';
import { ReactComponent as DurationIcon } from './Duration.svg';
import { ReactComponent as CostIcon } from './Cost.svg';
import { ReactComponent as BriefcaseIcon } from './Briefcase.svg';
import StrategyIcons from './strategies';

export default {
    ErrorIcon,
    InfoIcon,
    FAQIcon,
    DownloadIcon,
    CloseIcon,
    ProfileIcon,
    SearchIcon,
    SettingsIcon,
    UploadIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    ArrowDownIcon,
    PointerLeftIcon,
    PointerRightIcon,
    PointerUpIcon,
    PointerDownIcon,
    CalendarIcon,
    MenuIcon,
    RSVPIcon,
    ClockIcon,
    CourseCodeIcon,
    LinkIcon,
    ExternalLinkIcon,
    QualificationIcon,
    DurationIcon,
    CostIcon,
    BriefcaseIcon,
    ...StrategyIcons,
};
